import { Avatar, Stack, Typography } from '@mui/material';
import { MaterialIcon } from '@common/ui/MaterialIcon';

export default function AccessSessionHeader({
  icon,
  name,
  typeName,
  withArrow = true,
}: {
  icon: string;
  name: string;
  typeName: string;
  withArrow?: boolean;
}) {
  return (
    <Stack direction="row" alignItems="center" spacing={1} sx={{ flex: 1 }}>
      {withArrow && <MaterialIcon symbol="arrow_right_alt" color="success" />}
      <Avatar alt="access-session-header" src={icon} sx={{ width: 20, height: 20 }} />
      <Stack>
        <Typography variant="subtitle2">{name}</Typography>
        <Typography variant="inputLabel" color="text.muted">
          {typeName}
        </Typography>
      </Stack>
    </Stack>
  );
}
